<br><p-fieldset legend="Decretos de Nomeação" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="portNomecaoFiscal"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Atas" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="atafiscal"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Certificados" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="certificadosFiscal"></app-lista-arquivos>
</p-fieldset>


